import React from "react"
import Button from "../../../shared/components/atoms/button/button"
import "./recommender-question.scss"

const RecommenderQuestion = ({
  numberQuestion,
  questions,
  handleNextFilter,
  handlePrevFilter,
  answersTest,
  handleChangeAnswer,
}) => {
  return (
    <>
      <div className="f-question-container">
        <h3 className="f-question__text">
          {questions[numberQuestion].pregunta}
        </h3>
        <ul className="f-questions-container">
          {questions[numberQuestion].referenciaRespuestas &&
            questions[numberQuestion].referenciaRespuestas.map(
              (question, index) => {
                return (
                  <li
                    key={index}
                    className="f-question-item"
                    onClick={() => handleChangeAnswer(numberQuestion, index)}
                  >
                    <img
                      className="f-question-item__img"
                      loading="lazy"
                      src={question.imagenRespuesta.file.url}
                      alt={question.imagenRespuesta.description}
                    />
                    <div className={`f-question-item__answer `}>
                      <span
                        className={`f-question-item__indicator   ${
                          answersTest[numberQuestion] === index ? "active" : ""
                        } `}
                      />
                      <p>{question.repuesta}</p>
                    </div>
                  </li>
                )
              }
            )}
        </ul>
      </div>
      <div className="recommender-next">
        {numberQuestion !== 0 && (
          <Button
            className="new-primary-pink--outline short "
            title="Anterior"
            onClick={handlePrevFilter}
          />
        )}
        <Button
          className="new-primary-pink short "
          title="Siguiente"
          onClick={handleNextFilter}
        />
      </div>
    </>
  )
}

export default RecommenderQuestion
